import { render, staticRenderFns } from "./filmBoxoffice.vue?vue&type=template&id=8690eb68&scoped=true&"
import script from "./filmBoxoffice.vue?vue&type=script&lang=js&"
export * from "./filmBoxoffice.vue?vue&type=script&lang=js&"
import style0 from "./filmBoxoffice.vue?vue&type=style&index=0&id=8690eb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8690eb68",
  null
  
)

export default component.exports